module.exports = __webpack_public_path__ + "img/woshou.1ba42099.jpg";